import { Text } from "@artprov/design-system";
import PropTypes from "prop-types";

/**
 * Card de detalle para matching judicial con soporte para campos en 1 o 2 columnas
 */
const JudicialDetailCard = ({ title, fields = [], titleRightContent }) => {
    const renderField = (field) => {
        const valueContent = field.valueNode ?? (
            <Text variant="body2" className={`text-tertiary-10 font-semibold${field.fullWidth ? " whitespace-pre-line" : ""}`}>
                {field.value || "-"}
            </Text>
        );

        if (field.fullWidth) {
            // Campo que ocupa toda la fila
            return (
                <div key={field.label} className="flex flex-col gap-1 col-span-2">
                    <Text variant="body2" className="text-tertiary-60">
                        {field.label}
                    </Text>
                    <div className="flex items-center gap-2">
                        {valueContent}
                    </div>
                </div>
            );
        }

        // Campo en 2 columnas
        return (
            <div key={field.label} className="flex flex-col gap-1">
                <Text variant="body2" className="text-tertiary-60">
                    {field.label}
                </Text>
                <div className="flex items-center gap-2">
                    {valueContent}
                </div>
            </div>
        );
    };

    return (
        <div className="bg-tertiary-100 border border-tertiary-95 rounded py-6 px-4">
            {/* Título */}
            <div className="flex items-center justify-between">
                <Text variant="subtitle1" className="text-primary-10">
                    {title}
                </Text>
                {titleRightContent}
            </div>

            {/* Línea divisoria */}
            <div className="h-px bg-tertiary-80 my-4" />

            {/* Grid de 2 columnas */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-4">
                {fields.map((field) => renderField(field))}
            </div>
        </div>
    );
};

JudicialDetailCard.propTypes = {
    title: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            fullWidth: PropTypes.bool,
            valueNode: PropTypes.node,
        })
    ),
    titleRightContent: PropTypes.node,
};

export default JudicialDetailCard;
